// extracted by mini-css-extract-plugin
module.exports = {"root":"Cashback_root__z8Oja","amount":"Cashback_amount__LXkZA","recieveBtn":"Cashback_recieveBtn__23OU5","untilNext":"Cashback_untilNext__rKO9s"};